import { createMultiStyleConfigHelpers, ComponentStyleConfig, cssVar } from '@chakra-ui/react';
import { popoverAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(popoverAnatomy.keys);

const $arrowShadowColor = cssVar('popper-arrow-shadow-color');

const baseStyle = definePartsStyle({
  content: {
    border: 'none',
    borderRadius: 'lg',
    boxShadow: 'md',
    [$arrowShadowColor.variable]: `colors.utility.100`,
    _dark: {
      boxShadow: 'dark-md',
      [$arrowShadowColor.variable]: `transparent`,
    },
  },
  header: {
    fontWeight: 'bold',
    borderBottom: 'none',
    pt: 4,
    pb: 0,
    px: 4,
  },
  body: {
    px: 4,
    py: 4,
  },
  footer: {
    borderTop: 0,
    pt: 0,
    pb: 4,
    px: 4,
  },
  closeButton: {
    insetEnd: 1,
  },
});

export const popoverTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
});
